// Styles - srini - 21/11/24
const styles = theme => ({

    dialogPaper: {
        background: 'linear-gradient(135deg, #1A1A1A 0%, #333333 100%)',
        color: '#fff',
        borderRadius: '10px',
        boxShadow: 'none',
        padding: theme.spacing(2),
        maxWidth: '500px',
        transition: 'transform 0.3s ease-in-out',
        '&:focus': {
            outline: 'none',
        },
    },

    cnfCllTxt:{
        color: '#fff !important',
        fontFamily: 'cardiuma-regular ! important',
        fontSize: '18px ! important',
        fontWeight: 500,
        letterSpacing: '0.5px !important',
        textAlign: 'center',
    },

    ayswtCllTxt:{
        color: '#fff !important',
        fontFamily: 'cardiuma-regular ! important',
        fontSize: '14px ! important',
        fontWeight: 400,
        textAlign: 'center',
        lineHeight: 1.5,
        letterSpacing: '0.5px !important'
    },

    cnclBtn:{
        color: '#F44748 !important',
        fontFamily: 'cardiuma-SemiBold ! important',
        fontSize: '16px ! important',
        fontWeight: 500,
        textTransform: 'none !important',
        borderRadius: '5px',
        '&:hover': {
            backgroundColor: 'rgba(244, 71, 72, 0.1)',
            transform: 'scale(1.05)', 
        },
    },

    cnfBtn:{
        color: '#7DAA1C !important',
        fontFamily: 'cardiuma-SemiBold ! important',
        fontSize: '16px ! important',
        fontWeight: 500,
        textTransform: 'none !important',
        borderRadius: '5px',
        '&:hover': {
            backgroundColor: 'rgba(65, 171, 28, 0.1)',
            transform: 'scale(1.05)',
        },
    }
})

export default styles